import type { DeepPartial } from '../types';
import { merge } from 'es-toolkit/compat';
import { darken, lighten } from 'polished';
import { baseTheme } from './base';

export const createTheme = (theme: DeepPartial<typeof baseTheme>) => {
  const mergedTheme = merge(baseTheme, theme);
  const main = theme.colors?.primary?.main;
  if (main) {
    mergedTheme.colors.primary.ultraDark = darken(0.15, main);
    mergedTheme.colors.primary.dark = main;
    mergedTheme.colors.primary.toku = lighten(0.1, main);
    mergedTheme.colors.primary.light1 = lighten(0.15, main);
    mergedTheme.colors.primary.light2 = lighten(0.2, main);
    mergedTheme.colors.primary.light3 = lighten(0.25, main);
    mergedTheme.colors.primary.light4 = lighten(0.3, main);
    mergedTheme.colors.primary.light5 = lighten(0.35, main);
  }
  return mergedTheme;
};
